import React, { useMemo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { t } from "i18next";
import PropTypes from "prop-types";
import { getAvailabilityRecords } from "~/store/actions/actions.availabilityRecords.jsx";
import { getAvailabilityTypes } from "~/store/actions/actions.availabilityTypes.jsx";
import { loadUsersWorkweekCapacities } from "~/store/actions/actions.users";
import { makeUserAvailabilityRecordsForSelectDateSelector } from "~/store/selectors/selector.availabilityRecords.jsx";
import { makeGetUserNonWorkingDaysSelector } from "~/store/selectors/selector.daysOff.jsx";
import { getUserById, isLoggedUserClientSelector } from "~/store/selectors/selector.users.jsx";
import SelectDateNonWorkingDays from "./SelectDateNonWorkingDays.jsx";
import useAcSelectDate from "../Hooks/useAcSelectDate.jsx";

const SelectDateUserDaysOff = ({ userId, ...props }) => {
  const dispatch = useDispatch();
  const { today } = useAcSelectDate();
  const timestamp = today.clone().startOf("month").unix();
  const isLoggedUserClient = useSelector(isLoggedUserClientSelector);
  const getUserAvailabilityRecordsForSelectDate = useMemo(
    () => makeUserAvailabilityRecordsForSelectDateSelector(userId, timestamp, "user_day_off"),
    [userId, timestamp]
  );

  useEffect(() => {
    if (userId > 0) {
      Promise.all([
        dispatch(
          getAvailabilityRecords(userId, {
            from: today.clone().subtract(1, "month").startOf("month").format("YYYY-MM-DD"),
            to: today.clone().add(1, "year").endOf("month").format("YYYY-MM-DD"),
          })
        ),
        dispatch(getAvailabilityTypes()),
        !isLoggedUserClient && dispatch(loadUsersWorkweekCapacities()),
      ]);
    }
  }, [userId, dispatch, today, isLoggedUserClient]);

  const getUserNonWorkingDays = useMemo(() => makeGetUserNonWorkingDaysSelector(userId), [userId]);

  const userNonWorkingDays = useSelector(getUserNonWorkingDays);
  const user = useSelector((state) => getUserById(state, userId));

  const records = useSelector(getUserAvailabilityRecordsForSelectDate);
  return (
    <SelectDateNonWorkingDays
      {...props}
      userAvailability={records}
      userNonWorkingDays={userNonWorkingDays}
      userNonWorkingDaysLabel={`${user?.display_name}: ${t("Unavailable")}`}
    />
  );
};

SelectDateUserDaysOff.propTypes = {
  userId: PropTypes.number,
};

export default SelectDateUserDaysOff;
